import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ProductGrid } from "./ProductGrid";
export const ShopTabs = () => {
  return <Tabs defaultValue="tshirts" className="w-full max-w-7xl mx-[5px] px-[5px]">
      <TabsList className="w-full justify-start mb-6">
        <TabsTrigger value="tshirts">Camisetas</TabsTrigger>
        <TabsTrigger value="hoodies">Moletons</TabsTrigger>
        <TabsTrigger value="misc">Produtos Diversos</TabsTrigger>
      </TabsList>
      <TabsContent value="tshirts">
        <ProductGrid category="tshirts" />
      </TabsContent>
      <TabsContent value="hoodies">
        <ProductGrid category="hoodies" />
      </TabsContent>
      <TabsContent value="misc">
        <ProductGrid category="misc" />
      </TabsContent>
    </Tabs>;
};